var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.has_router)?_c(_vm.$attrs.tag || 'span',_vm._g(_vm._b({tag:"component",on:{"click":_vm.on_click}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('router-link',_vm._g(_vm._b({attrs:{"to":_vm.to}},'router-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }